import { createZodDto } from './zod';

import { z } from 'zod';

const HabilitationFieldsSchema = z.object({
  typeId: z.number().int(),
  // Date d'obtention/de renouvellement effective, pas une échéance
  // planifiée — ne doit pas être dans le futur.
  date: z.coerce.date(),
  // Formation justificative, toujours optionnelle même quand le type
  // l'exige — pas de blocage API pour éviter l'œuf-et-la-poule avec
  // Training. Absente alors que requise, l'habilitation est simplement
  // non conforme (voir HabilitationService#trainingContribution).
  trainingId: z.number().int().positive().nullable().default(null),
  filesIds: z.number().array().default([]),
});

const isDateNotInFuture = (data: { date: Date }) => data.date <= new Date();

export const CreateHabilitationSchema = HabilitationFieldsSchema.extend({
  userId: z.number().int(),
}).refine(isDateNotInFuture, {
  message: 'Habilitation date cannot be in the future',
  path: ['date'],
});

// The employee is immutable once an habilitation exists — a justificatif
// (attestation, linked training) is legally tied to the employee it was
// recorded for, see HabilitationService.
export const UpdateHabilitationSchema = HabilitationFieldsSchema.refine(
  isDateNotInFuture,
  {
    message: 'Habilitation date cannot be in the future',
    path: ['date'],
  },
);

export class HabilitationCreateDto extends createZodDto(
  CreateHabilitationSchema,
) {}

export class HabilitationUpdateDto extends createZodDto(
  UpdateHabilitationSchema,
) {}
